import React, { useState } from 'react';
import { func, shape } from 'prop-types';

import { useInitFetchApi } from '../StockBuySell/hooks';
import { useInitAmendForm, useSubmitAmend } from './hooks';
import StockBuySellHeader from '../StockBuySell/StockBuySellHeader';
import StockBuySellNotes from '../StockBuySell/StockBuySellNotes';
import StockAmendForm from './StockAmendForm';
import StockAmendSubmitBtn from './StockAmendSubmitBtn';
import {
  PopUpAutoSimulation,
  PopUpAutoTnc,
  PopUpAvailableLot,
  PopUpConfirmation,
  PopUpDtApiError,
} from '../StockBuySell/components';
import { ORDER_DETAIL_SHAPE } from './adapter';
import { styStockAmendContainer, styBodyContainer } from './style';

const StockAmend = (props) => {
  const { orderDetail, onCancel } = props;
  const code = orderDetail?.code ?? '';

  const [popup, setPopup] = useState({ open: '', data: null });

  useInitFetchApi(code, { orderDetail });
  useInitAmendForm({ orderDetail });

  const hidePopup = () => {
    setPopup({ open: '' });
  };

  const { isLoading: isLoadingSubmit, submitAmend } = useSubmitAmend(code, {
    onSuccess: () => {
      hidePopup();
      onCancel();
    },
    onDtError: (data) => setPopup({ open: 'DT_API_ERROR', data }),
  });

  const handleSubmit = () => {
    setPopup({ open: 'CONFIRMATION' });
  };

  return (
    <section className={styStockAmendContainer}>
      <StockBuySellHeader code={code} />
      <div className={styBodyContainer}>
        <StockAmendForm
          code={code}
          onClickAutoOrderInfo={() => setPopup({ open: 'AUTO_ORDER_SIMULATION' })}
          onClickAvailableLotInfo={() => setPopup({ open: 'AVAILABLE_LOT' })}
          onSubmit={handleSubmit}
        />
        <StockBuySellNotes code={code} onClickTNC={() => setPopup({ open: 'AUTO_ORDER_TNC' })} />
      </div>
      <StockAmendSubmitBtn
        code={code}
        orderDetail={orderDetail}
        onCancel={onCancel}
        onSubmit={handleSubmit}
      />

      <PopUpConfirmation
        show={popup.open === 'CONFIRMATION'}
        onHide={hidePopup}
        onConfirm={submitAmend}
        isLoadingSubmit={isLoadingSubmit}
      />

      <PopUpAvailableLot show={popup.open === 'AVAILABLE_LOT'} onHide={hidePopup} />
      <PopUpAutoSimulation show={popup.open === 'AUTO_ORDER_SIMULATION'} onHide={hidePopup} />
      <PopUpAutoTnc show={popup.open === 'AUTO_ORDER_TNC'} onHide={hidePopup} />
      <PopUpDtApiError
        errCode={popup.data}
        show={popup.open === 'DT_API_ERROR'}
        onHide={hidePopup}
      />
    </section>
  );
};

StockAmend.propTypes = {
  orderDetail: shape(ORDER_DETAIL_SHAPE),
  onCancel: func,
};

StockAmend.defaultProps = {
  orderDetail: {},
  onCancel: () => {},
};

export default StockAmend;
